/*
 * @Description: 视频中心pc端骨架屏
 * @Author: liuzhezhe
 * @Date: 2023-06-29 13:38:47
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2023-07-06 09:48:36
 */
import React, { useEffect, useState } from 'react'
import styles from './index.scss'

const VideoPcScreen = (props) => {
  const [state] = useState([1, 2, 3, 4])
  useEffect(() => {

  }, [])

  return (
    <div className={styles['order-skeletons']}>
      {/* <div className={styles['iframe']}> */}
      <div className={styles['iframe-left']}>
        <div className={styles['skeletons']}></div>
        <div className={styles['skeletons']}></div>
        <div className={styles['skeletons']}></div>
      </div>
      <div className={styles['iframe-right']}>
        {state.map(item => (
          <div className={styles['order-item']} key={item}>
            <div className={styles['skeletons']}></div>
            <div className={styles['skeletons']}></div>
            <div className={styles['skeletons']}></div>
          </div>
        ))}
      </div>
      {/* </div> */}
    </div>
  )
}

export default VideoPcScreen

